import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LoadingState } from "@repo/app-types/client/client";
import type { PaymentMethodInfo } from "@repo/app-types/entities/balanceTransaction";
import { getAxiosInstanceWithAuth } from "../../api/axiosConfig.js";
import type { RootState } from "../../app/store.js";

export interface BillingState {
  billing: BillingInfo;
}
export interface BillingInfo {
  defaultPaymentMethod: PaymentMethodInfo | null;
  status: LoadingState;
  error: string | null;
}

const initialState: BillingState = {
  billing: {
    defaultPaymentMethod: null,
    status: LoadingState.LOADING,
    error: null,
  },
};

export const fetchBillingInfo = createAsyncThunk(
  "billing/fetch",
  async (_args, thunkAPI) => {
    try {
      const axios = await getAxiosInstanceWithAuth();
      const { data } = await axios.get(`/billing/info`);

      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

// Slice
const billingSlice = createSlice({
  name: "billing",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBillingInfo.pending, (state) => {
        state.billing.status = LoadingState.LOADING;
      })
      .addCase(fetchBillingInfo.fulfilled, (state, action) => {
        state.billing.status = LoadingState.LOADED;
        state.billing.defaultPaymentMethod =
          action.payload.default_payment_method;
      })
      .addCase(fetchBillingInfo.rejected, (state, action) => {
        state.billing.status = LoadingState.ERROR;
        state.billing.error = action.error.message || null;
      });
  },
});

export default billingSlice.reducer;

export const selectBillingInfo = (state: RootState) => state.billing.billing;
export const selectDefaultPaymentMethod = (state: RootState) =>
  state.billing.billing.defaultPaymentMethod;
export const selectBillingLoadingState = (state: RootState) =>
  state.billing.billing.status;
